/** Refresh JWT cookie name */
export const refreshTokenCookieName = 'DSR';
/** Session JWT cookie name */
export const sessionTokenCookieName = 'DS';
/** The key of the tenants claims in the claims map */
export const authorizedTenantsClaimName = 'tenants';
/** The key of the permissions claims in the claims map either under tenant or top level */
export const permissionsClaimName = 'permissions';
/** The key of the roles claims in the claims map either under tenant or top level */
export const rolesClaimName = 'roles';
